import { FC, memo, ReactNode, useEffect, useState } from "react"
import ReactDOM from "react-dom"
import styles from "./index.module.scss"
import dynamic from "next/dynamic"


interface IProps {
    children: ReactNode,
    className?: string,
    visible: boolean
    onClose?: () => void
    closeable?: boolean
    closeBtn?: boolean
    okbtn?: boolean
    oktext?: string
    closeContent?: ReactNode
}

const Modal: FC<IProps> = ({ children, className, visible, onClose, closeable, closeBtn, okbtn, oktext, closeContent }) => {

    const [modalVisible, setModalVisible] = useState(false)

    useEffect(() => {
        if (visible) {
            document.body.style.overflow = "hidden"

            setTimeout(() => {
                setModalVisible(true)
            }, 100)
        }
        else {
            closeModal()
        }

        return () => {
            document.body.style.overflow = "auto"
        }
    }, [visible])

    const closeModal = () => {
        setModalVisible(false)

        setTimeout(() => {
            onClose?.()
        }, 400)
    }

    const submitButton = () => {
        const Button = dynamic(() => import("components/_button/landing"))

        return <Button
            className={styles.submit_btn__content + " w100 mt-sm"}
            btnType="action"
            onClick={closeModal}
        >
            {
                oktext ?? "متوجه شدم"
            }
        </Button>
    }




    if (!visible) return null
    return (
        ReactDOM.createPortal(
            <div onClick={() => (closeable && onClose) && closeModal()} className={styles.modal + ` ${modalVisible ? styles.visible : styles.hide}`}>
                <div
                    onClick={(e) => e.stopPropagation()}
                    className={styles.modal__content + " " + (className ?? "")}
                >
                    {
                        (onClose && closeBtn) &&

                        <button
                            className={styles.modal_close + " transparent btn"}
                            onClick={closeModal}
                        >
                            {closeContent ? closeContent : <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="13" cy="13" r="13" fill="#7E869E" fillOpacity="0.25" />
                                <path d="M8.66602 8.66699L17.3327 17.3337" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
                                <path d="M17.334 8.66699L8.66732 17.3337" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
                            </svg>}
                        </button>
                    }

                    {children}

                    {
                        (okbtn && onClose) && submitButton()
                    }
                </div>
            </div>
            , document.getElementById("modal"))
    )
}


export default memo(Modal)